import { Component, Input, OnChanges, OnDestroy, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { ShopPlugin } from '@pdqdev/pdq-shared/dist/interfaces';

@Component({
  selector: 'label-component-preview',
  templateUrl: './label-component-preview.component.html',
  styleUrls: ['./label-component-preview.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class LabelComponentPreviewComponent implements OnChanges, OnDestroy {
  @Input() options: ShopPlugin.ProductPagePromise.LabelOptions;

  iconSrc: string = '';

  private currentObjectUrl: string | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options']) {
      this.refreshIconSrc();
    }
  }

  ngOnDestroy(): void {
    this.revokeObjectUrl();
  }

  private refreshIconSrc(): void {
    const value = this.options?.iconUrl as unknown;
    this.revokeObjectUrl();
    if (typeof value === 'string') {
      this.iconSrc = value;
    } else if (value instanceof File) {
      this.currentObjectUrl = URL.createObjectURL(value);
      this.iconSrc = this.currentObjectUrl;
    } else {
      this.iconSrc = '';
    }
  }

  private revokeObjectUrl(): void {
    if (this.currentObjectUrl) {
      URL.revokeObjectURL(this.currentObjectUrl);
      this.currentObjectUrl = null;
    }
  }
}
